// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__qNQ62","small":"Button_small__pybTS"};